import { render } from "./Summary_Vertical.vue?vue&type=template&id=13255c04&scoped=true"
import script from "./Summary_Vertical.vue?vue&type=script&lang=js"
export * from "./Summary_Vertical.vue?vue&type=script&lang=js"

import "./Summary_Vertical.vue?vue&type=style&index=0&id=13255c04&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13255c04"]])

export default __exports__